import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Table,
  Input,
  Breadcrumb,
  Space,
  Popconfirm,
  Button,
  Tooltip,
  Row,
} from "antd";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import SearchIcon from "../../image/SearchIcon.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { authUserData } from "../../utils/Helper";

import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { getRequest, postRequest } from "../../axios";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";

const CompanyDocumentsList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companydocumentsList, setCompanyDocumentsList] = useState([]);
  const [totalCount, settotalCount] = useState(0);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getcompanydocumentsList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          `company-document/${CompanyId}/company-by-document/`,
          state
        );
        if (apiResponse.data.results.success) {
          setCompanyDocumentsList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("eroor_in_company_document_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getcompanydocumentsList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "document_name" && sortOrder === "ascend") {
      sortingEnumKey = "document_name";
    }
    if (sortField === "document_name" && sortOrder === "descend") {
      sortingEnumKey = "-document_name";
    }
    if (sortField === "upload_document" && sortOrder === "ascend") {
      sortingEnumKey = "upload_document";
    }
    if (sortField === "upload_document" && sortOrder === "descend") {
      sortingEnumKey = "-upload_document";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const columns = [
    {
      title: "Documents Type",
      width: "300px",
      dataIndex: "document_name",
      key: "document_name",
      sorter: true,
    },
    {
      title: "Documents File",
      dataIndex: "upload_document",
      key: "upload_document",
      sorter: true,
      render: (upload_document) =>
        upload_document && (
          <>
            <a
              style={{ textDecoration: "none", color: "black" }}
              href={`${upload_document}`}
              download
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={upload_document}
                style={{ width: "50px", height: "50px" }}
                alt=""
              />
            </a>
          </>
        ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          <Link
            to={{
              pathname: "/company-documents/edit/" + btoa(record.id),
            }}
          >
            {authUserData()?.permission.includes(
              "company_document|change_companydocument"
            ) && <Editicon />}
          </Link>
          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            {authUserData()?.permission.includes(
              "company_document|delete_companydocument"
            ) && <Archive style={{ cursor: "pointer" }} />}
          </Popconfirm>
          {/* <DownloadOutlined /> */}
        </Space>
      ),
    },
  ];

  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("company-document-delete/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("company_document_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_archive_list"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("pl_company_documents")}</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_company_documents")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {authUserData()?.permission.includes(
              "company_document|add_companydocument"
            ) && (
              <Button
                className="BlueShadowBtn"
                type="primary"
                onClick={() => navigate("/company-documents/add")}
                icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
              >
                {t("pl_add_documents")}
              </Button>
            )}
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                {authUserData()?.permission.includes(
                  "company_document|delete_companydocument"
                ) && (
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={t("pl_archive")}
                  />
                )}
              </Popconfirm>
            )}
            <Tooltip placement="topLeft" title="Archived Records">
              <Link to="/company-documents/archive" className="Archiveicon">
                <Archiveicon />
              </Link>
            </Tooltip>
          </Space>
          {/* {authUserData()?.permission.includes(
            "company_document|add_companydocument"
          ) && (
            <Button
              className="BlueShadowBtn"
              type="primary"
              onClick={() => navigate("/company-documents/add")}
              icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
            >
              {t("pl_add_documents")}
            </Button>
          )} */}
        </div>
      </div>

      <section className="grid-sec mt-5">
        <div className="PR-body">
          <Row className="tblheader">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-heading">
            <h1>

              {t("pl_company_documents")}
            </h1>
          </Col> */}

            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>

            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                {authUserData()?.permission.includes(
                  "company_document|delete_companydocument"
                ) && (
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={t("pl_archive")}
                  />
                )}
              </Popconfirm>
            )}
            <Tooltip placement="topLeft" title="Archived Records">
              <Link to="/company-documents/archive" className="Archiveicon">
                <Archiveicon />
              </Link>
            </Tooltip>
          </Col> */}
          </Row>

          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={companydocumentsList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
            }}
            onChange={handleTableChange}
          />
        </div>
      </section>
    </>
  );
};

export default CompanyDocumentsList;
